import { ObjectId } from 'bson';
import { Type } from 'class-transformer';
import { IsDate, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { BaseDto } from './base.dto';
import { EntityDeletionReason, EntityStatus } from './entity-state.enum';

export class EntityStateDto {
  @IsEnum(EntityStatus, {
    message: `status must be a valid EntityStatus: ${Object.values(EntityStatus).join(', ')}`,
  })
  status: EntityStatus = EntityStatus.ACTIVE;

  @IsOptional()
  @IsDate({ message: 'firstActivatedAt must be a valid Date' })
  firstActivatedAt?: Date;

  @IsOptional()
  @IsDate({ message: 'activatedAt must be a valid Date' })
  activatedAt?: Date;

  @IsOptional()
  @IsDate({ message: 'deactivatedAt must be a valid Date' })
  deactivatedAt?: Date;

  @IsOptional()
  @IsDate({ message: 'deletedAt must be a valid Date' })
  deletedAt?: Date;

  @IsOptional()
  @IsString()
  note?: string;

  @IsOptional()
  @IsEnum(EntityDeletionReason, {
    message: `reason must be a valid EntityDeletionReason: ${Object.values(EntityDeletionReason).join(', ')}`,
  })
  reason?: EntityDeletionReason;
}

export class PatchEntityStateDto {
  @IsEnum(EntityStatus, {
    message: `status must be a valid EntityStatus: ${Object.values(EntityStatus).join(', ')}`,
  })
  status: EntityStatus = EntityStatus.ACTIVE;

  @IsOptional()
  @IsString()
  note?: string;

  @IsOptional()
  @IsEnum(EntityDeletionReason, {
    message: `reason must be a valid EntityDeletionReason: ${Object.values(EntityDeletionReason).join(', ')}`,
  })
  reason?: EntityDeletionReason;
}

export class EntityStateSchemaDto<TId extends ObjectId> extends BaseDto<TId> {
  @ValidateNested()
  @Type(() => EntityStateDto)
  @IsNotEmpty()
  state!: EntityStateDto;
}
